import CallsToAciton from '@components/calls-to-action/calls-to-action.view';
import ComponentRenderer from '@components/cms-components/component-renderer/component-renderer.view';
import { Madi, Yeseva } from 'app/fonts';
import classNames from 'classnames';
import type { ReactElement } from 'react';
import { ComponentTypes } from 'types/components/component-types';
import type { StackedHeaderData } from 'types/components/stacked-header';
import type { DataProps } from 'types/props/data-props';

import StackedHeader from './stacked-header.view';

function StackedHeaderComponent({
  context,
  cursiveHeading = false,
  description,
  eyebrow,
  heading,
  images,
  layout = 'left',
  subHeading,
  primaryCta,
  secondaryCta,
  theme,
}: DataProps<StackedHeaderData>): ReactElement {
  return (
    <StackedHeader
      callsToAction={
        <CallsToAciton
          primaryCta={primaryCta}
          secondaryCta={secondaryCta}
          theme={theme}
        />
      }
      description={
        <ComponentRenderer context={context}>{description}</ComponentRenderer>
      }
      eyebrow={
        typeof eyebrow !== 'undefined' ? <span>{eyebrow}</span> : undefined
      }
      heading={
        <h1
          className={classNames({
            [Madi.className]: cursiveHeading === true,
            [Yeseva.className]: cursiveHeading === false,
          })}
        >
          <ComponentRenderer context={context}>{heading}</ComponentRenderer>
        </h1>
      }
      layout={layout}
      media={
        typeof images !== 'undefined' ? (
          <ComponentRenderer context={context}>
            {{
              _type: ComponentTypes.StackedImages,
              images,
              priority: true,
              sizes: '(max-width: 768px) 100vw, 50vw',
            }}
          </ComponentRenderer>
        ) : undefined
      }
      size={cursiveHeading === true ? 'large' : 'medium'}
      subHeading={
        typeof subHeading !== 'undefined' ? (
          <span>{subHeading}</span>
        ) : undefined
      }
      theme={theme}
    />
  );
}

export default StackedHeaderComponent;
